// removed by extract-text-webpack-plugin
module.exports = {"container":"purify_ServiceStats__container___2j8Nh","wrap":"purify_ServiceStats__wrap___2Of_z","gas":"purify_ServiceStats__gas___x6OQX"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/shared/Service/ServiceStats/ServiceStats.scss
// module id = 214
// module chunks = 0